import { defineMessages } from 'react-intl-next';

export const messages: {
	tier: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	tier: {
		id: 'search-page.relay.compass.tier',
		defaultMessage: 'Tier {tier}',
		description:
			'Indicates how critical the component is to your business. The lower the tier, the higher the criticality.',
	},
});
